<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import CompanyService from "@/services/company";

export default {
  page: {
    title: "Mensagens",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: "Mensagens",
      settings: {
        abandoned_cart_message: {},
        change_status_message: {},
        closed_store_message: {},
      },
      loading: false
    };
  },
  methods: {
    load(showLoading = true) {
      let loader;
      if (showLoading) {
        loader = this.$loading.show();
      }

      CompanyService.getCompanyData().then(res => {
        this.settings = res.data.settings;

        if (loader) {
          loader.hide();
        }
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao carregar os dados');

        if (loader) {
          loader.hide();
        }
      })
    },
    save() {
      let loader = this.$loading.show();

      const data = {
        settings: this.settings,
      }

      CompanyService.updateCompanyData(data).then(() => {
        this.$toast.open('Configurações atualizadas com sucesso');
        this.load(false);

        loader.hide();
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao atualizar os dados');
        loader.hide();
      })
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Carrinho Abandonado</h4>
            <p class="card-title-desc">Mensagem automática enviada para os usuários que abandonam o carrinho de compras sem enviar o pedido</p>

            <form>
              <div class="row mt-4">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="custom-control custom-checkbox mb-0">
                      <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="settings.abandoned_cart_message.send" />
                      <label class="custom-control-label" for="customCheck1">Enviar mensagem de carrinho abandonado</label>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row mt-0">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="abandonedCartTitle">Título da Mensagem</label>
                        <input id="abandonedCartTitle" name="abandonedCartTitle" type="text" class="form-control" v-if="settings.abandoned_cart_message.send" :maxlength="50" v-model="settings.abandoned_cart_message.title" />
                        <input id="abandonedCartTitle" name="abandonedCartTitle" type="text" class="form-control" v-if="!settings.abandoned_cart_message.send" disabled/>
                        <div v-if="settings.abandoned_cart_message.send && settings.abandoned_cart_message.title" class="text-left  ">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.abandoned_cart_message.title.length !== 50,
                            'badge-danger': settings.abandoned_cart_message.title.length === 50 }"
                          >{{ settings.abandoned_cart_message.title.length }} / 50</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-sm-9">
                      <div class="form-group">
                        <label for="abandonedCartMessage">Corpo da Mensagem</label>
                        <input id="abandonedCartMessage" name="abandonedCartMessage" type="text" class="form-control" v-if="settings.abandoned_cart_message.send" :maxlength="150" v-model="settings.abandoned_cart_message.message" />
                        <input id="abandonedCartMessage" name="abandonedCartMessage" type="text" class="form-control" v-if="!settings.abandoned_cart_message.send" disabled />
                        <div v-if="settings.abandoned_cart_message.message && settings.abandoned_cart_message.send" class="text-left  ">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.abandoned_cart_message.message.length !== 150,
                            'badge-danger': settings.abandoned_cart_message.message.length === 150 }"
                          >{{ settings.abandoned_cart_message.message.length }} / 150</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Atualização de Status</h4>
            <p class="card-title-desc">Mensagens enviadas na alteração do status para informar o cliente sobre o andamento do pedido</p>

            <form>
              <div class="row mt-0 mb-2">
                <div class="col-sm-12">
                  <!-- <div class="row mb-0">
                    <div class="col-sm-12">
                      <div class="form-group mb-1">
                        <div class="custom-control custom-checkbox mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusConfirmed" v-model="settings.change_status_message.send_confirmed" />
                          <label class="custom-control-label" for="changeStatusConfirmed">Pedido Confirmado</label>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  
                  <div class="row mt-0">
                    <div class="col-sm-3">
                      <div class="form-group mb-0">
                        <div class="custom-control custom-checkbox mt-2 mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusConfirmed" v-model="settings.change_status_message.send_confirmed" />
                          <label class="custom-control-label" for="changeStatusConfirmed">Pedido Confirmado</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <!-- <label for="name">Título</label> -->
                        <input type="text" class="form-control" :maxlength="50" v-if="settings.change_status_message.send_confirmed" v-model="settings.change_status_message.title_confirmed" />
                        <input type="text" class="form-control" :maxlength="50" v-if="!settings.change_status_message.send_confirmed" disabled />
                        <div v-if="settings.change_status_message.title_confirmed && settings.change_status_message.send_confirmed" class="text-left">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.title_confirmed.length !== 50,
                            'badge-danger': settings.change_status_message.title_confirmed.length === 50 }"
                          >{{ settings.change_status_message.title_confirmed.length }} / 50</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <!-- <label for="manufacturername">Mensagem</label> -->
                        <input class="form-control" :maxlength="150" v-if="settings.change_status_message.send_confirmed" v-model="settings.change_status_message.confirmed" />
                        <input class="form-control" :maxlength="150" v-if="!settings.change_status_message.send_confirmed" disabled />
                        <div v-if="settings.change_status_message.confirmed && settings.change_status_message.send_confirmed" class="text-left  ">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.confirmed.length !== 150,
                            'badge-danger': settings.change_status_message.confirmed.length === 150 }"
                          >{{ settings.change_status_message.confirmed.length }} / 150</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-0 mb-2">
                <div class="col-sm-12">
                  <!-- <div class="row mb-0">
                    <div class="col-sm-12">
                      <div class="form-group mb-1">
                        <div class="custom-control custom-checkbox mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusSeparation" v-model="settings.change_status_message.send_separation" />
                          <label class="custom-control-label" for="changeStatusSeparation">Pedido Em Separação</label>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  
                  <div class="row mt-0">
                    <div class="col-sm-3">
                      <div class="form-group mb-0 mt-2">
                        <div class="custom-control custom-checkbox mb-0 mt-2">
                          <input type="checkbox" class="custom-control-input" id="changeStatusSeparation" v-model="settings.change_status_message.send_separation" />
                          <label class="custom-control-label" for="changeStatusSeparation">Pedido Em Separação</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <!-- <label for="name">Título</label> -->
                        <input type="text" class="form-control" :maxlength="50" v-if="settings.change_status_message.send_separation" v-model="settings.change_status_message.title_separation" />
                        <input type="text" class="form-control" :maxlength="50" v-if="!settings.change_status_message.send_separation" disabled />
                        <div v-if="settings.change_status_message.title_separation && settings.change_status_message.send_separation" class="text-left">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.title_separation.length !== 50,
                            'badge-danger': settings.change_status_message.title_separation.length === 50 }"
                          >{{ settings.change_status_message.title_separation.length }} / 50</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <!-- <label for="manufacturername">Mensagem</label> -->
                        <input type="text" class="form-control" :maxlength="150" v-if="settings.change_status_message.send_separation" v-model="settings.change_status_message.separation" />
                        <input type="text" class="form-control" :maxlength="150" v-if="!settings.change_status_message.send_separation" disabled />
                        <div v-if="settings.change_status_message.separation && settings.change_status_message.send_separation" class="text-left">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.separation.length !== 150,
                            'badge-danger': settings.change_status_message.separation.length === 150 }"
                          >{{ settings.change_status_message.separation.length }} / 150</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-0 mb-2">
                <div class="col-sm-12">
                  <!-- <div class="row mb-0">
                    <div class="col-sm-12">
                      <div class="form-group mb-1">
                        <div class="custom-control custom-checkbox mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusSent" v-model="settings.change_status_message.send_sent" />
                          <label class="custom-control-label" for="changeStatusSent">Pedido Enviado</label>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  
                  <div class="row mt-0">
                    <div class="col-sm-3">
                      <div class="form-group mb-0 mt-2">
                        <div class="custom-control custom-checkbox mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusSent" v-model="settings.change_status_message.send_sent" />
                          <label class="custom-control-label" for="changeStatusSent">Pedido Enviado</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <!-- <label for="name">Título</label> -->
                        <input type="text" class="form-control" :maxlength="50" v-if="settings.change_status_message.send_sent" v-model="settings.change_status_message.title_sent" />
                        <input type="text" class="form-control" :maxlength="50" v-if="!settings.change_status_message.send_sent" disabled />
                        <div v-if="settings.change_status_message.title_sent && settings.change_status_message.send_sent" class="text-left">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.title_sent.length !== 50,
                            'badge-danger': settings.change_status_message.title_sent.length === 50 }"
                          >{{ settings.change_status_message.title_sent.length }} / 50</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <!-- <label for="manufacturername">Mensagem</label> -->
                        <input type="text" class="form-control" :maxlength="150" v-if="settings.change_status_message.send_sent" v-model="settings.change_status_message.sent" />
                        <input type="text" class="form-control" :maxlength="150" v-if="!settings.change_status_message.send_sent" disabled />
                        <div v-if="settings.change_status_message.sent && settings.change_status_message.send_sent" class="text-left  ">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.sent.length !== 150,
                            'badge-danger': settings.change_status_message.sent.length === 150 }"
                          >{{ settings.change_status_message.sent.length }} / 150</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-0 mb-2">
                <div class="col-sm-12">
                  <!-- <div class="row mb-0">
                    <div class="col-sm-12">
                      <div class="form-group mb-1">
                        <div class="custom-control custom-checkbox mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusReady" v-model="settings.change_status_message.send_ready" />
                          <label class="custom-control-label" for="changeStatusReady">Pedido Pronto p/ Retirada</label>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  
                  <div class="row mt-0">
                    <div class="col-sm-3">
                      <div class="form-group mb-1 mt-2">
                        <div class="custom-control custom-checkbox mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusReady" v-model="settings.change_status_message.send_ready" />
                          <label class="custom-control-label" for="changeStatusReady">Pedido Pronto p/ Retirada</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <!-- <label for="name">Título</label> -->
                        <input type="text" class="form-control" :maxlength="50" v-if="settings.change_status_message.send_ready" v-model="settings.change_status_message.title_ready" />
                        <input type="text" class="form-control" :maxlength="50" v-if="!settings.change_status_message.send_ready" disabled />
                        <div v-if="settings.change_status_message.title_ready && settings.change_status_message.send_ready" class="text-left">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.title_ready.length !== 50,
                            'badge-danger': settings.change_status_message.title_ready.length === 50 }"
                          >{{ settings.change_status_message.title_ready.length }} / 50</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <!-- <label for="manufacturername">Mensagem</label> -->
                        <input type="text" class="form-control" :maxlength="150" v-if="settings.change_status_message.send_ready" v-model="settings.change_status_message.ready" />
                        <input type="text" class="form-control" :maxlength="150" v-if="!settings.change_status_message.send_ready" disabled />
                        <div v-if="settings.change_status_message.ready && settings.change_status_message.send_ready" class="text-left  ">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.ready.length !== 150,
                            'badge-danger': settings.change_status_message.ready.length === 150 }"
                          >{{ settings.change_status_message.ready.length }} / 150</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-0 mb-2">
                <div class="col-sm-12">
                  <!-- <div class="row mb-0">
                    <div class="col-sm-12">
                      <div class="form-group mb-1">
                        <div class="custom-control custom-checkbox mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusDelivered" v-model="settings.change_status_message.send_delivered" />
                          <label class="custom-control-label" for="changeStatusDelivered">Pedido Entregue</label>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  
                  <div class="row mt-0">
                    <div class="col-sm-3">
                      <div class="form-group mb-0 mt-2">
                        <div class="custom-control custom-checkbox mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusDelivered" v-model="settings.change_status_message.send_delivered" />
                          <label class="custom-control-label" for="changeStatusDelivered">Pedido Entregue</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <!-- <label for="name">Título</label> -->
                        <input type="text" class="form-control" :maxlength="50" v-if="settings.change_status_message.send_delivered" v-model="settings.change_status_message.title_delivered" />
                        <input type="text" class="form-control" :maxlength="50" v-if="!settings.change_status_message.send_delivered" disabled />
                        <div v-if="settings.change_status_message.title_delivered && settings.change_status_message.send_delivered" class="text-left">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.title_delivered.length !== 50,
                            'badge-danger': settings.change_status_message.title_delivered.length === 50 }"
                          >{{ settings.change_status_message.title_delivered.length }} / 50</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <!-- <label for="manufacturername">Mensagem</label> -->
                        <input type="text" class="form-control" :maxlength="150" v-if="settings.change_status_message.send_delivered" v-model="settings.change_status_message.delivered" />
                        <input type="text" class="form-control" :maxlength="150" v-if="!settings.change_status_message.send_delivered" disabled />
                        <div v-if="settings.change_status_message.delivered && settings.change_status_message.send_delivered" class="text-left  ">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.delivered.length !== 150,
                            'badge-danger': settings.change_status_message.delivered.length === 150 }"
                          >{{ settings.change_status_message.delivered.length }} / 150</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-0 mb-2">
                <div class="col-sm-12">
                  <!-- <div class="row mb-0">
                    <div class="col-sm-12">
                      <div class="form-group mb-1">
                        <div class="custom-control custom-checkbox mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusCompleted" v-model="settings.change_status_message.send_completed" />
                          <label class="custom-control-label" for="changeStatusCompleted">Pedido Finalizado</label>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  
                  <div class="row mt-0">
                    <div class="col-sm-3">
                      <div class="form-group mb-0 mt-2">
                        <div class="custom-control custom-checkbox mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusCompleted" v-model="settings.change_status_message.send_completed" />
                          <label class="custom-control-label" for="changeStatusCompleted">Pedido Finalizado</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <!-- <label for="name">Título</label> -->
                        <input type="text" class="form-control" :maxlength="50" v-if="settings.change_status_message.send_completed" v-model="settings.change_status_message.title_completed" />
                        <input type="text" class="form-control" :maxlength="50" v-if="!settings.change_status_message.send_completed" disabled />
                        <div v-if="settings.change_status_message.title_completed && settings.change_status_message.send_completed" class="text-left">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.title_completed.length !== 50,
                            'badge-danger': settings.change_status_message.title_completed.length === 50 }"
                          >{{ settings.change_status_message.title_completed.length }} / 50</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <!-- <label for="manufacturername">Mensagem</label> -->
                        <input type="text" class="form-control" :maxlength="150" v-if="settings.change_status_message.send_completed" v-model="settings.change_status_message.completed" />
                        <input type="text" class="form-control" :maxlength="150" v-if="!settings.change_status_message.send_completed" disabled />
                        <div v-if="settings.change_status_message.completed && settings.change_status_message.send_completed" class="text-left  ">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.completed.length !== 150,
                            'badge-danger': settings.change_status_message.completed.length === 150 }"
                          >{{ settings.change_status_message.completed.length }} / 150</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-0 mb-2">
                <div class="col-sm-12">
                  <!-- <div class="row mb-0">
                    <div class="col-sm-12">
                      <div class="form-group mb-1">
                        <div class="custom-control custom-checkbox mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusCanceled" v-model="settings.change_status_message.send_canceled" />
                          <label class="custom-control-label" for="changeStatusCanceled">Pedido Cancelado</label>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  
                  <div class="row mt-0">
                    <div class="col-sm-3">
                      <div class="form-group mb-0 mt-2">
                        <div class="custom-control custom-checkbox mb-0">
                          <input type="checkbox" class="custom-control-input" id="changeStatusCanceled" v-model="settings.change_status_message.send_canceled" />
                          <label class="custom-control-label" for="changeStatusCanceled">Pedido Cancelado</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <!-- <label for="name">Título</label> -->
                        <input type="text" class="form-control" :maxlength="50" v-if="settings.change_status_message.send_canceled" v-model="settings.change_status_message.title_canceled" />
                        <input type="text" class="form-control" :maxlength="50" v-if="!settings.change_status_message.send_canceled" disabled />
                        <div v-if="settings.change_status_message.title_canceled && settings.change_status_message.send_canceled" class="text-left">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.title_canceled.length !== 50,
                            'badge-danger': settings.change_status_message.title_canceled.length === 50 }"
                          >{{ settings.change_status_message.title_canceled.length }} / 50</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <!-- <label for="manufacturername">Mensagem</label> -->
                        <input type="text" class="form-control" :maxlength="150" v-if="settings.change_status_message.send_canceled" v-model="settings.change_status_message.canceled" />
                        <input type="text" class="form-control" :maxlength="150" v-if="!settings.change_status_message.send_canceled" disabled />
                        <div v-if="settings.change_status_message.canceled && settings.change_status_message.send_canceled" class="text-left  ">
                          <p
                            class="badge position-absolute"
                            :class="{ 'badge-soft-secondary': settings.change_status_message.canceled.length !== 150,
                            'badge-danger': settings.change_status_message.canceled.length === 150 }"
                          >{{ settings.change_status_message.canceled.length }} / 150</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Loja Fechada</h4>
            <p class="card-title-desc">Mensagem exibida para o usuário caso a loja esteja fora do horário de atendimento</p>

            <form>
              <div class="row mt-0">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-sm-5">
                      <div class="form-group">
                        <label for="closedStoreMessageTitle">Título</label>
                        <input id="closedStoreMessageTitle" name="closedStoreMessageTitle" type="text" class="form-control" v-model="settings.closed_store_message.title" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-sm-5">
                      <div class="form-group">
                        <label for="closedStoreMessageMessage">Mensagem</label>
                        <textarea id="closedStoreMessageMessage" name="closedStoreMessageMessage" class="form-control" rows="5" v-model="settings.closed_store_message.message"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="text-sm-right mb-4">
      <button type="button" class="btn btn-primary btn-rounded" @click="save">Salvar Configurações</button>
    </div>
  </Layout>
</template>